import React from 'react'
import { FeatureUnavailable } from 'admin-web-ui'

export const VoiceCallingTeaser: React.FC = () => (
  <FeatureUnavailable
    pageHeading="Voice Calling"
    ctaHeading="Bring more secure voice calls to your customers"
    ctaDescription={`
      Enable your apps to make and receive voice calls to any phone number 
      globally, just like a cellphone, but much more secure.
    `}
    ctaSubDescription={`
      Make and recieve calls, Caller ID and reputation, Custom voicemail, 
      Call blocking, and more.
    `}
    ctaLink="https://sudoplatform.com/open-communications/voice-calling/"
    imagePath="/images/img-voice-calling"
  />
)
